import React from 'react';
import SimpleList from '../../components/List.jsx';
import '../../styles/capacidades.css';

export default function Capacidades() {
    return (
        <div className="capacidadesView">
            <div className="capacidadesView-head">
                <h1 className="titulo">Capacidades por default</h1>
                <p className="desc">
                    Visualiza la capacidad default de todas las líneas y edita sus características.
                </p>
            </div>
            <div className="capacidadesView-body">
                <SimpleList />
            </div>
        </div>
    );
}
